import { Controller } from "@hotwired/stimulus"

// Stopwatch for work order items — greasy-hands simple
// Displays elapsed time, syncs with server-tracked started_at
export default class extends Controller {
  static targets = ["display", "bar"]
  static values = {
    startedAt: Number,    // Unix timestamp when started (0 = not started)
    pausedDuration: Number, // Total paused seconds
    estimatedMinutes: Number, // Target time in minutes
    paused: Boolean       // Currently paused?
  }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.startedAtValue || this.startedAtValue === 0) return
    if (this.pausedValue) return // Don't tick while paused

    const now = Math.floor(Date.now() / 1000)
    const elapsed = now - this.startedAtValue
    const active = Math.max(elapsed - (this.pausedDurationValue || 0), 0)

    // Update display
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.formatTime(active)
    }

    // Update progress bar
    if (this.hasBarTarget && this.estimatedMinutesValue > 0) {
      const targetSec = this.estimatedMinutesValue * 60
      const pct = Math.min((active / targetSec) * 100, 100)
      this.barTarget.style.width = pct + '%'

      // Color: green under 80%, yellow 80-100%, red over
      if (active > targetSec) {
        this.barTarget.className = 'stopwatch-bar stopwatch-over'
      } else if (pct > 80) {
        this.barTarget.className = 'stopwatch-bar stopwatch-warn'
      } else {
        this.barTarget.className = 'stopwatch-bar stopwatch-good'
      }
    }
  }

  formatTime(seconds) {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
    return `${m}:${String(s).padStart(2,'0')}`
  }
}
